var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRangePin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.147 47.039v-.001l-1.719-2.1-.002-.002a351.976 351.976 0 01-7.064-9.085c-2.628-3.516-5.05-6.971-6.015-8.94v-.001C.3 22.737-.045 17.695 1.413 13.08c1.524-4.72 4.643-8.476 8.768-10.606h0l.003-.002A16.775 16.775 0 0118.056.522c6.695 0 12.725 3.811 15.744 9.966.007.019.017.04.03.061 2.638 5.466 2.58 11.458-.132 16.455l-.003.004c-1.197 2.255-4.417 6.675-7.381 10.584a425.749 425.749 0 01-5.664 7.293l-.002.002-1.663 2.13s0 0 0 0c-.228.29-.563.455-.912.461h-.017c-.346 0-.68-.158-.909-.44z",
    fill: "#F4F4F4",
    stroke: "#D8D8D8",
    strokeWidth: 1.043
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.122 8.197l-7.582 5.698V26.93h5.645a31.17 31.17 0 01-.166-.97c-.11-.667-.11-1.334-.277-2-.166-.607.11-1.092.332-1.576l.111-.243c.055-.121.166-.243.277-.364.72-.727 1.992-.97 2.933-.485.72.303 1.052 1.273 1.107 2.061.111 1.213.166 2.425-.221 3.576h5.479V13.896l-7.638-5.698z",
    fill: "#58B847"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "range_pin_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 18,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.37 8.197h17.56V31.61H9.37V8.197z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#range_pin_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.525 13.914l-7.94-5.585c-.29-.177-.638-.177-.87 0l-7.998 5.585c-.232.117-.348.353-.348.647V27.2c0 .47.348.824.812.824h5.969a.798.798 0 00.812-.824c0-.058 0-.176-.058-.235l-.059-.176c-.29-.706-.637-1.588-.637-2.47v-.176c-.058-.53.116-1.058.464-1.411a2 2 0 011.333-.706c.521-.058.985.118 1.391.471s.638.823.695 1.353v.175c.058 1.176-.695 2.882-.81 3.058L18.178 29.2l-.174-.353c-.116-.176-.29-.352-.464-.411-.173-.059-.405-.059-.579.059-.174.117-.348.294-.406.47-.058.177-.058.412.058.588l.87 1.647c.115.235.405.41.694.41.29 0 .58-.175.697-.41l1.738-3.293h5.506a.798.798 0 00.811-.823V14.56c-.057-.294-.173-.53-.405-.647zm-4.865 9.76a3.474 3.474 0 00-1.218-2.41c-.695-.647-1.622-.94-2.55-.882-1.796.117-3.245 1.705-3.245 3.527 0 .765.116 1.53.406 2.411h-4.057V14.973l7.128-4.998 7.187 4.998v11.406h-4.056c.173-.647.405-1.646.405-2.47v-.235z",
    fill: "#000"
  }))));
}
export default SvgRangePin;